import React, {memo} from 'react';
import PropTypes from 'prop-types';

import {SVGIcon} from '@homeaway/react-svg';

// SVGIcon.whyDidYouRender = true;

import {useComponent} from './hooks/useComponent';

import './SearchIcon.less';

const SearchIcon = memo(function SearchIcon(props) {
    const {
        className,
        showSmallIcon,
        showLargeIcon,
        smallIconClassName,
        largeIconClassName,
        smallIconMarkup,
        largeIconMarkup
    } = useComponent(props);

    return (
        <span className={className}>
            {showSmallIcon && (
                <SVGIcon
                    className={smallIconClassName}
                    markup={smallIconMarkup}
                />
            )}
            {showLargeIcon && (
                <SVGIcon
                    className={largeIconClassName}
                    markup={largeIconMarkup}
                />
            )}
        </span>
    );
});

SearchIcon.propTypes = {
    name: PropTypes.string.isRequired,
    size: PropTypes.oneOf(['auto', 'small', 'large']).isRequired
};

SearchIcon.defaultProps = {
    size: 'auto'
};

SearchIcon.whyDidYouRender = true;

export {SearchIcon};
